import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private http: HttpClient, private router: Router) { }

  public post(url: string, formData: FormData) {
    this.http.post(url, formData).subscribe(
      (res: any) => {
        if (res.isError) {
          alert(
            res.message
          );
        } else {
          this.router.navigate(['request-ack']);
        }
      },
      (err) => {
        alert(
          'در ثبت پیام مشکلی بوجود آمده است. لطفا دوباره تلاش نمایید و یا با پشتیبانی کارگزاری تماس حاصل فرمایید'
        );
        console.log('error in sending mail', err);
      }
    );
  }

  public get(path: string, headers?: any, options?: any) {
    if (headers) {
      return this.http.get(path, {
        headers: new HttpHeaders(headers),
        params: options
      }).pipe(tap(data => data));
    }

    if (options?.responseType) {
      return this.http.get(path, { responseType: options.responseType }).pipe(tap(res => res));
    }

    return this.http.get(path).pipe(tap(data => data));
  }
}
